import { BridgeComponent } from "@hotwired/hotwire-native-bridge";

class DownloadComponent extends BridgeComponent {
    static component = "download";

    download(event) {
        event.stopImmediatePropagation();
        event.preventDefault();
        this.#downlaodFile();
    }

    #downlaodFile() {
        const downloadLink = this.bridgeElement.bridgeAttribute("link");
        this.send("download", { downloadLink }, () => {});
    }
}

export default DownloadComponent;
